import headerLogos from '@/assets/agritour-header-logos-transparent.png';
import { CompanyLogo } from '@/components/CompanyLogo';
import {
  AGRITOUR_FORM_TITLE,
  AGRITOUR_SECTIONS,
  AGRITOUR_SUPPORT,
  AGRITOUR_WELCOME,
} from './agritour-form-copy';
import styles from './AgriTourScreen.module.css';

export function AgriTourSiteHeader({ title, variant = 'default' }: { title?: string; variant?: 'default' | 'map' }) {
  const heroClass =
    variant === 'map'
      ? `${styles.hero} ${styles.heroMap}`
      : `${styles.hero}${title ? ` ${styles.heroWithTitle}` : ''}`;

  return (
    <header className={heroClass}>
      <div className={styles.heroInner}>
        <img
          src={headerLogos}
          alt="מרכז היתרים אשכול גליל מזרחי | אשכול גליל מזרחי"
          className={styles.heroLogos}
          decoding="async"
        />
        {title && variant !== 'map' ? <h1 className={styles.heroTitle}>{title}</h1> : null}
      </div>
    </header>
  );
}

export function AgriTourClicksFooter({
  compact = false,
  showSupport = true,
}: {
  compact?: boolean;
  showSupport?: boolean;
}) {
  const supportTel = `+972${AGRITOUR_SUPPORT.phone.replace(/^0/, '')}`;

  return (
    <footer className={`${styles.clicksFooter}${compact ? ` ${styles.clicksFooterCompact}` : ''}`}>
      {showSupport ? (
        compact ? (
          <p className={styles.supportFooterCompact}>
            {AGRITOUR_SUPPORT.label}
            {' · '}
            <a href={`tel:${supportTel}`} className={styles.supportFooterLink}>
              {AGRITOUR_SUPPORT.phone}
            </a>
          </p>
        ) : (
          <p className={styles.supportFooter}>
            <span>{AGRITOUR_SUPPORT.label}</span>
            {' '}
            <a href={`tel:${supportTel}`} className={styles.supportFooterLink}>
              {AGRITOUR_SUPPORT.phone}
            </a>
            {' '}
            <a href={`mailto:${AGRITOUR_SUPPORT.email}`} className={styles.supportFooterLink}>
              {AGRITOUR_SUPPORT.email}
            </a>
          </p>
        )
      ) : null}
      <div className={styles.clicksFooterBrand} aria-label="Clicks Strategic Ecosystems">
        <span className={styles.siteFooterLabel}>מופעל בידי</span>
        <CompanyLogo height={42} />
      </div>
    </footer>
  );
}

export function AgriTourWelcome({ onStart }: { onStart: () => void }) {
  return (
    <div className={styles.page} dir="rtl" lang="he">
      <AgriTourSiteHeader />
      <div className={styles.container}>
        <div className={styles.welcomeCard}>
          <div className={styles.welcomeBadge} aria-hidden>
            <span className={styles.welcomeBadgeIcon}>🌾</span>
          </div>
          <h1 className={styles.welcomeTitle}>{AGRITOUR_WELCOME.title}</h1>
          {AGRITOUR_WELCOME.paragraphs.map((line) => (
            <p key={line} className={styles.welcomeBody}>{line}</p>
          ))}
          <button type="button" className={styles.btnPrimary} onClick={onStart}>
            {AGRITOUR_WELCOME.button}
          </button>
          <p className={styles.welcomeDraftNote}>{AGRITOUR_WELCOME.draftNote}</p>
        </div>
      </div>
      <AgriTourClicksFooter />
    </div>
  );
}

export const AGRITOUR_STEP_LABELS = [
  AGRITOUR_SECTIONS.a.stepLabel,
  AGRITOUR_SECTIONS.b.stepLabel,
  AGRITOUR_SECTIONS.c.stepLabel,
  AGRITOUR_SECTIONS.d.stepLabel,
];

export { AGRITOUR_FORM_TITLE, AGRITOUR_SECTIONS };
